// longer than default one since it is CPU intensive for backend.
export const STALE_TIME_ANALYTICS_MS = 5 * 60 * 1000

export const MODEL = "reports"
